import { render, staticRenderFns } from "./orderByWorkshop.vue?vue&type=template&id=c5e9d34c&scoped=true"
import script from "./orderByWorkshop.vue?vue&type=script&lang=js"
export * from "./orderByWorkshop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e9d34c",
  null
  
)

export default component.exports